<template>
  <div class="font-sans bg-neutrals_background text-neutrals_text min-h-screen">
    <header class="shadow sticky top-0 z-50 h-[70px] lg:h-[120px]" style="background: rgba(241, 233, 212, 0.5); backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px); border-bottom: 1px solid rgba(255, 255, 255, 0.4);">
      <div class="max-w-7xl mx-auto px-4 flex items-center justify-between h-full">

        <!-- Logo -->
        <div class="flex items-center">
          <img src="@/assets/images/Ativo 3logo 1.png" class="h-16 lg:h-28 w-auto -mt-0" />
        </div>

        <!-- Botão Mobile -->
        <button @click="toggleMenu" class="lg:hidden p-2 rounded hover:bg-white/10 transition">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path v-if="mobileMenu" stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            <path v-else stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <!-- Menu Mobile -->
        <transition name="slide-fade">
          <nav v-if="mobileMenu"
            class="lg:hidden absolute inset-x-0 top-[70px] flex flex-col space-y-6 p-6 shadow-2xl z-40 border-b border-accent/40" style="background: rgba(241, 233, 212, 0.95); backdrop-filter: blur(12px); color: #163C53;">

            <router-link to="/" class="text-primary hover:text-accent text-lg font-bold" @click="toggleMenu">Início</router-link>
            <router-link to="/categorias" class="text-primary hover:text-accent text-lg font-bold" @click="toggleMenu">Categorias</router-link>
            <router-link to="/contato" class="text-primary hover:text-accent text-lg font-bold" @click="toggleMenu">Contato</router-link>

            <div class="border-t border-white/20 pt-6"></div>

            <div v-if="!isLoggedIn">
              <button @click="goToLogin"
                class="w-full bg-white/10 border border-white/20 px-5 py-3 rounded-lg hover:bg-white/20 transition duration-300">
                Entrar
              </button>
            </div>

            <div v-else class="flex flex-col space-y-2">
              <button v-if="isAdmin" @click="handleUserAction('dashboard')" class="w-full text-left px-4 py-2 hover:bg-white/10 rounded">Painel Administrativo</button>
              <button v-else @click="handleUserAction('meuAnuncio')" class="w-full text-left px-4 py-2 hover:bg-white/10 rounded">Meu Anúncio</button>
              <button @click="handleUserAction('changePassword')" class="w-full text-left px-4 py-2 hover:bg-white/10 rounded">Alterar Senha</button>
              <button @click="handleUserAction('logout')" class="w-full text-left px-4 py-2 text-red-400 hover:bg-white/10 rounded">Sair</button>
            </div>
          </nav>
        </transition>

        <!-- Nav Desktop -->
        <nav class="hidden lg:flex justify-center space-x-10 text-[16px] font-semibold">
          <router-link to="/" class="text-primary hover:text-accent transition-colors">Início</router-link>
          <router-link to="/categorias" class="text-primary hover:text-accent transition-colors">Categorias</router-link>
          <router-link to="/contato" class="text-primary hover:text-accent transition-colors">Contato</router-link>
        </nav>

        <!-- Área do usuário Desktop -->
        <div class="hidden lg:flex justify-end gap-4 items-center">

          <button v-if="userName" @click="handleCreateAd"
            class="flex items-center gap-2 bg-accent text-white font-semibold px-5 py-2 rounded-full shadow hover:bg-secondary hover:scale-105 transition-transform duration-300">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M3 4a1 1 0 0 1 1-1h4l1 2h8l1-2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z" />
            </svg>
            <span>Meu Anúncio</span>
          </button>

          <div class="relative">
            <template v-if="isLoggedIn">
              <button
                class="flex items-center gap-2 border-2 border-primary text-primary px-4 py-2 rounded-full hover:bg-primary hover:text-white transition duration-300"
                @click.stop="toggleUserMenu">
                <span class="font-medium">{{ userName }}</span>
                <svg xmlns="http://www.w3.org/2000/svg"
                  class="w-4 h-4 transition-transform duration-300" :class="{ 'rotate-180': showUserMenu }"
                  fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              <transition name="fade">
                <div v-if="showUserMenu"
                  class="absolute right-0 mt-2 w-48 bg-white text-gray-800 rounded-lg shadow-lg overflow-hidden z-50">
                  <button v-if="isAdmin" @click="handleUserAction('dashboard')"
                    class="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition">Painel Administrativo</button>
                  <button v-else @click="handleUserAction('meuAnuncio')"
                    class="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition">Meu Anúncio</button>
                  <button @click="handleUserAction('changePassword')"
                    class="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition">Alterar Senha</button>
                  <div class="border-t border-gray-100"></div>
                  <button @click="handleUserAction('logout')"
                    class="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100 transition">Sair</button>
                </div>
              </transition>
            </template>

            <template v-else>
              <button @click="goToLogin"
                class="flex items-center justify-center gap-2 px-8 py-2.5 rounded-full transition-all duration-300 uppercase"
                style="border: 2px solid #163C53; color: #163C53; font-weight: 900; letter-spacing: 1px; font-size: 0.9rem;"
                @mouseenter="$event.target.style.backgroundColor='#163C53'; $event.target.style.color='#fff'"
                @mouseleave="$event.target.style.backgroundColor='transparent'; $event.target.style.color='#163C53'">
                <span>Entrar</span>
              </button>
            </template>
          </div>
        </div>

      </div>
    </header>

    <!-- HERO -->
    <section
      class="relative h-[280px] sm:h-[360px] bg-cover bg-center flex flex-col items-center justify-start pt-[70px] lg:pt-[120px]"
      style="background-image: url('banner-marketplace.jpg')">
      <div class="absolute inset-0 bg-primary/70"></div>

      <div class="relative z-10 text-center text-white px-6 mb-8">
        <h1 class="text-3xl sm:text-4xl font-extrabold mb-2 drop-shadow">
          O maior marketplace da região
        </h1>
        <p class="text-base sm:text-lg opacity-90">
          Encontre as melhores empresas e serviços da sua cidade.
        </p>
      </div>

      <!-- BUSCA -->
      <div class="relative z-20 w-[92%] sm:w-[70%] bg-white rounded-xl shadow-xl p-4
          flex flex-col sm:flex-row gap-3 sm:gap-2 items-stretch sm:items-center -mb-24 sm:-mb-16">

        <input v-model="filters.keyword" placeholder="Buscar empresas ou serviços..."
          class="w-full border rounded-lg px-3 py-3 text-sm focus:ring-2 focus:ring-primary" />

        <select v-model="filters.category_id"
          class="w-full sm:w-1/3 border rounded-lg px-3 py-3 text-sm focus:ring-2 focus:ring-primary text-gray-700">
          <option value="">Todas as Categorias</option>
          <option v-for="category in categories" :key="category.id" :value="category.id">
            {{ category.description }}
          </option>
        </select>

        <select v-model="filters.state"
          class="w-full sm:w-1/4 border rounded-lg px-3 py-3 text-sm focus:ring-2 focus:ring-primary text-gray-700">
          <option v-for="uf in brazilStates" :key="uf.value" :value="uf.value">{{ uf.label }}</option>
        </select>

        <button @click="searchAds"
          class="w-full sm:w-auto bg-primary text-white px-5 py-3 rounded-lg text-sm transition hover:bg-secondary text-center"
          :class="{ 'opacity-50 cursor-not-allowed': loading }">
          <div v-if="loading" class="flex items-center justify-center gap-2">
            <svg class="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0..." />
            </svg>
            Buscando...
          </div>
          <span v-else>Buscar</span>
        </button>

      </div>
    </section>

    <!-- Destaques -->
    <section v-if="premiumAds.length" class="max-w-7xl mx-auto px-4 mt-48 sm:mt-20 pt-10 pb-8">
      <h2 class="text-3xl font-bold mb-8 text-center text-accent">
        Anúncios em Destaque
      </h2>

      <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
        <div v-for="ad in premiumAds" :key="ad.id"
          class="relative block bg-neutrals-surface rounded-xl shadow hover:shadow-lg overflow-hidden transition-all group border-2 border-accent">

          <div class="cursor-pointer" @click="goToAd(ad)">
            <img :src="ad.images[0]"
              class="w-full h-44 sm:h-52 object-cover group-hover:scale-105 transition-transform duration-500" />

            <div class="p-3 sm:p-4">
              <h3 class="text-base font-semibold truncate mb-1 text-accent">
                {{ ad.title }}
              </h3>

              <p class="text-sm text-gray-500 truncate">
                {{ ad.category?.description || 'Sem categoria' }}
              </p>

              <p class="text-gray-400 text-xs mt-1">
                {{ ad.city }} - {{ ad.state }}
              </p>

              <div class="mt-2 flex items-start gap-2 text-xs text-primary font-semibold">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor" class="w-4 h-4 mt-[1px]">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7l9-4 9 4-9 4-9-4z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 17l9 4 9-4M3 12l9 4 9-4" />
                </svg>

                <span>
                  {{ ad.coverage === 'local'
                      ? 'Atende somente sua cidade / região'
                      : ad.coverage === 'state'
                      ? 'Atende todo o estado'
                      : ad.coverage === 'national'
                      ? 'Atende todo o Brasil'
                      : '' }}
                </span>
              </div>
            </div>
          </div>

          <div class="p-3 border-t flex justify-center">
            <a :href="`https://wa.me/${sanitizePhone('55' + ad.client?.phone)}`" target="_blank"
              rel="noopener noreferrer"
              class="flex items-center gap-2 bg-accent text-white px-4 py-2 rounded-full hover:bg-accent/80 transition">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                style="width: 20px; height: 20px;">
                <path
                  d="M12.04 2C6.5 2 2 6.5 2 12.04c0 1.84.48 3.62 1.39 5.2L2 22l4.9-1.28A9.97 9.97 0 0 0 12.04 22C17.55 22 22 17.55 22 12.04S17.55 2 12.04 2zm0 18.21a8.2 8.2 0 0 1-4.17-1.14l-.3-.18-2.48.64.66-2.57-.17-.27A8.13 8.13 0 0 1 3.84 12c0-4.54 3.68-8.21 8.2-8.21 2.19 0 4.25.86 5.8 2.42a8.16 8.16 0 0 1 2.4 5.79c0 4.53-3.68 8.21-8.2 8.21zm4.56-6.17c-.25-.12-1.47-.72-1.7-.8-.23-.08-.4-.12-.57.12-.17.25-.65.8-.8.96-.15.17-.3.19-.55.08-.25-.12-1.06-.39-2.02-1.24-.74-.66-1.24-1.48-1.38-1.73-.14-.25-.01-.39.11-.52.12-.12.25-.3.37-.45.12-.15.16-.25.25-.42.08-.17.04-.32-.02-.45-.06-.12-.57-1.37-.78-1.88-.21-.5-.43-.43-.57-.44h-.48c-.17 0-.44.06-.67.32-.23.25-.88.86-.88 2.09 0 1.22.9 2.4 1.03 2.56.13.17 1.78 2.71 4.32 3.8.6.26 1.06.42 1.42.54.6.19 1.14.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.15-1.18-.06-.1-.22-.17-.47-.29z" />
              </svg>
              <span>WhatsApp</span>
            </a>
          </div>

        </div>
      </div>

      <div v-if="premiumHasMore" class="text-center mt-8">
        <button @click="getPremiumAdvertisements(true)"
          class="px-6 py-2 bg-accent text-white rounded-full hover:bg-accent/80 transition">
          Ver mais anúncios
        </button>
      </div>
    </section>

    <!-- Recentes -->
    <section class="max-w-7xl mx-auto px-4 pt-10 pb-14">
      <h2 class="text-2xl sm:text-3xl font-bold mb-8 text-center text-primary">
        Anúncios recentes
      </h2>

      <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
        <div v-for="ad in latestAds" :key="ad.id"
          class="relative block bg-neutrals-surface rounded-xl shadow hover:shadow-lg overflow-hidden transition-all group border">

          <div class="cursor-pointer" @click="goToAd(ad)">
            <img :src="ad.images[0]"
              class="w-full h-44 sm:h-52 object-cover group-hover:scale-105 transition-transform duration-500" />

            <div class="p-3 sm:p-4">
              <h3 class="text-base font-semibold truncate mb-1">
                {{ ad.title }}
              </h3>

              <p class="text-sm text-neutrals_muted truncate">
                {{ ad.category?.description || 'Sem categoria' }}
              </p>

              <p class="text-neutrals_muted text-xs mt-1">
                {{ ad.city }} - {{ ad.state }}
              </p>

              <div class="mt-2 flex items-start gap-2 text-xs text-primary font-semibold">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor" class="w-4 h-4 mt-[1px]">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7l9-4 9 4-9 4-9-4z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 17l9 4 9-4M3 12l9 4 9-4" />
                </svg>

                <span>
                  {{ ad.coverage === 'local'
                      ? 'Atende somente sua cidade / região'
                      : ad.coverage === 'state'
                      ? 'Atende todo o estado'
                      : ad.coverage === 'national'
                      ? 'Atende todo o Brasil'
                      : '' }}
                </span>
              </div>
            </div>
          </div>

          <div class="p-3 border-t flex justify-center">
            <a :href="`https://wa.me/${sanitizePhone('55' + ad.client?.phone)}`" target="_blank"
              rel="noopener noreferrer"
              class="flex items-center gap-2 bg-[#25D366] text-white px-4 py-2 rounded-full hover:bg-[#1EBE5A] transition">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                style="width: 24px; height: 24px;">
                <path
                  d="M12.04 2C6.5 2 2 6.5 2 12.04c0 1.84.48 3.62 1.39 5.2L2 22l4.9-1.28A9.97 9.97 0 0 0 12.04 22C17.55 22 22 17.55 22 12.04S17.55 2 12.04 2zm0 18.21a8.2 8.2 0 0 1-4.17-1.14l-.3-.18-2.48.64.66-2.57-.17-.27A8.13 8.13 0 0 1 3.84 12c0-4.54 3.68-8.21 8.2-8.21 2.19 0 4.25.86 5.8 2.42a8.16 8.16 0 0 1 2.4 5.79c0 4.53-3.68 8.21-8.2 8.21zm4.56-6.17c-.25-.12-1.47-.72-1.7-.8-.23-.08-.4-.12-.57.12-.17.25-.65.8-.8.96-.15.17-.3.19-.55.08-.25-.12-1.06-.39-2.02-1.24-.74-.66-1.24-1.48-1.38-1.73-.14-.25-.01-.39.11-.52.12-.12.25-.3.37-.45.12-.15.16-.25.25-.42.08-.17.04-.32-.02-.45-.06-.12-.57-1.37-.78-1.88-.21-.5-.43-.43-.57-.44h-.48c-.17 0-.44.06-.67.32-.23.25-.88.86-.88 2.09 0 1.22.9 2.4 1.03 2.56.13.17 1.78 2.71 4.32 3.8.6.26 1.06.42 1.42.54.6.19 1.14.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.15-1.18-.06-.1-.22-.17-.47-.29z" />
              </svg>
              <span>WhatsApp</span>
            </a>
          </div>

        </div>
      </div>
    </section>
    <!-- PAGINAÇÃO NORMAIS -->
    <div v-if="latestHasMore" class="text-center mb-6">
      <button @click="getLatestAdvertisements(true)"
        class="px-6 py-2 bg-primary text-white rounded-full hover:bg-primary/80 transition">
        Ver mais anúncios
      </button>
    </div>

    <!-- ✨ SEÇÃO DE EMPREGABILIDADE -->
    <section v-if="employabilityAds.length" class="max-w-7xl mx-auto px-4 pt-12 pb-10">
      <h2 class="text-3xl font-bold mb-8 text-center text-text">
        Oportunidades de Emprego
      </h2>

      <!-- GRID -->
      <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">

        <div v-for="ad in employabilityAds" :key="ad.id"
          class="relative block bg-white rounded-xl shadow-sm hover:shadow-md overflow-hidden transition-all group border-2 border-primary">

          <!-- CARD CLICK -->
          <div class="cursor-pointer" @click="goToAd(ad)">
            <img :src="ad.images[0]"
              class="w-full h-40 sm:h-48 object-cover group-hover:scale-105 transition-transform duration-500" />

            <div class="p-3 sm:p-4">
              <h3 class="text-base font-semibold truncate mb-1 text-primary">
                {{ ad.title }}
              </h3>

              <p class="text-sm text-neutrals_muted truncate">
                {{ ad.category?.description || 'Sem categoria' }}
              </p>

              <p class="text-neutrals_muted text-xs mt-1">
                {{ ad.city }} - {{ ad.state }}
              </p>
              <!-- ÁREA DE ATUAÇÃO -->
              <div class="mt-2 flex items-start gap-2 text-xs text-primary font-semibold">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                  class="w-4 h-4 mt-[1px]">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7l9-4 9 4-9 4-9-4z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 17l9 4 9-4M3 12l9 4 9-4" />
                </svg>

                <span>
                  {{ ad.coverage === 'local' ? 'Atende somente sua cidade / região' :
                    ad.coverage === 'state' ? 'Atende todo o estado' :
                      ad.coverage === 'national' ? 'Atende todo o Brasil' : '' }}
                </span>
              </div>
            </div>
          </div>

          <!-- BOTÃO WHATSAPP -->
          <div class="p-3 border-t flex justify-center">
            <a :href="`https://wa.me/${sanitizePhone('55' + ad.client?.phone)}`" target="_blank"
              rel="noopener noreferrer"
              class="flex items-center gap-2 bg-primary text-white px-4 py-2 rounded-full hover:bg-primary/80 transition">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                style="width: 20px; height: 20px;">
                <path
                  d="M12.04 2C6.5 2 2 6.5 2 12.04c0 1.84.48 3.62 1.39 5.2L2 22l4.9-1.28A9.97 9.97 0 0 0 12.04 22C17.55 22 22 17.55 22 12.04S17.55 2 12.04 2zm0 18.21a8.2 8.2 0 0 1-4.17-1.14l-.3-.18-2.48.64.66-2.57-.17-.27A8.13 8.13 0 0 1 3.84 12c0-4.54 3.68-8.21 8.2-8.21 2.19 0 4.25.86 5.8 2.42a8.16 8.16 0 0 1 2.4 5.79c0 4.53-3.68 8.21-8.2 8.21zm4.56-6.17c-.25-.12-1.47-.72-1.7-.8-.23-.08-.4-.12-.57.12-.17.25-.65.8-.8.96-.15.17-.3.19-.55.08-.25-.12-1.06-.39-2.02-1.24-.74-.66-1.24-1.48-1.38-1.73-.14-.25-.01-.39.11-.52.12-.12.25-.3.37-.45.12-.15.16-.25.25-.42.08-.17.04-.32-.02-.45-.06-.12-.57-1.37-.78-1.88-.21-.5-.43-.43-.57-.44h-.48c-.17 0-.44.06-.67.32-.23.25-.88.86-.88 2.09 0 1.22.9 2.4 1.03 2.56.13.17 1.78 2.71 4.32 3.8.6.26 1.06.42 1.42.54.6.19 1.14.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.15-1.18-.06-.1-.22-.17-.47-.29z" />
              </svg>
              <span>WhatsApp</span>
            </a>
          </div>
        </div>
      </div>

      <!-- PAGINAÇÃO -->
      <div v-if="employabilityHasMore" class="text-center mt-8">
        <button @click="getEmployabilityAdvertisements(true)"
          class="px-6 py-2 bg-primary text-white rounded-full hover:bg-primary/80 transition">
          Ver mais oportunidades
        </button>
      </div>
    </section>


    <section class="bg-primary text-white py-14 text-center">
      <h2 class="text-2xl sm:text-3xl font-bold mb-3">Quer vender mais rápido?</h2>
      <p class="mb-5 text-base sm:text-lg opacity-90">Anuncie agora mesmo e alcance milhares de pessoas.</p>
      <button @click="handleCreateAd"
        class="bg-accent text-white font-semibold py-3 px-8 rounded-full hover:bg-secondary hover:scale-105 transition-all">
        Criar Anúncio
      </button>
    </section>

    <!-- DIALOG ALTERAR SENHA -->
    <transition name="fade">
      <div v-if="showPasswordDialog" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white rounded-xl p-6 w-80 shadow-lg">
          <h3 class="text-lg font-semibold mb-4 text-gray-800">Alterar Senha</h3>

          <div class="space-y-3">
            <input type="password" v-model="passwordData.oldPassword" placeholder="Senha atual"
              class="border rounded-lg px-3 py-2 w-full text-sm focus:ring-2 focus:ring-primary focus:border-primary" />
            <input type="password" v-model="passwordData.newPassword" placeholder="Nova senha"
              class="border rounded-lg px-3 py-2 w-full text-sm focus:ring-2 focus:ring-primary focus:border-primary" />
            <input type="password" v-model="passwordData.confirmPassword" placeholder="Confirmar nova senha"
              class="border rounded-lg px-3 py-2 w-full text-sm focus:ring-2 focus:ring-primary focus:border-primary" />
          </div>

          <div class="flex justify-end gap-2 mt-5">
            <button @click="showPasswordDialog = false"
              class="text-sm px-4 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition">Cancelar</button>
            <button @click="changePassword"
              class="text-sm px-4 py-2 rounded-lg bg-primary text-white hover:bg-primary/80 transition">Salvar</button>
          </div>
        </div>
      </div>
    </transition>

    <AppFooter :enterprise="enterpriseData" />
    <Copyright :enterprise="enterpriseData" />
  </div>
</template>


<script setup>
import { ref, onMounted } from "vue";
import api from '@/services/api';
import { PALETTE } from "@/constants/colors.js";
import { useRouter } from "vue-router";
import Swal from "sweetalert2";

import AppFooter from '@/components/AppFooter.vue';
import Copyright from '@/components/Copyright.vue'

const router = useRouter();

const app_url_api_storage = process.env.VUE_APP_URL_API_STORAGE;
const mobileMenu = ref(false);
const filters = ref({ keyword: "", category_id: "", state: "" });

const showPasswordDialog = ref(false);
const isAdmin = ref(false);
const passwordData = ref({ oldPassword: "", newPassword: "", confirmPassword: "" });

const categories = ref([]);

const premiumAds = ref([]);
const latestAds = ref([]);
const employabilityAds = ref([])
const enterpriseData = ref({});

const loading = ref(false);
const showUserMenu = ref(false);
const userName = ref("");
const userID = ref("");
const isLoggedIn = ref(false);

const coverageLabels = {
  local: "Atende somente sua cidade / região",
  state: "Atende todo o estado",
  national: "Atende todo o Brasil"
};

// 🇧🇷 ESTADOS BRASILEIROS (para filtro)
const brazilStates = [
  { value: "", label: "Todos os Estados" },
  { value: "SP", label: "SP" },
  { value: "RJ", label: "RJ" },
  { value: "MG", label: "MG" },
  { value: "RS", label: "RS" },
  { value: "PR", label: "PR" },
  { value: "SC", label: "SC" },
  { value: "BA", label: "BA" },
  { value: "PE", label: "PE" },
  { value: "CE", label: "CE" },
  { value: "GO", label: "GO" },
  { value: "DF", label: "DF" },
];

function sanitizePhone(phone) {
  if (!phone) return "";
  return phone.replace(/\D/g, ""); // remove caracteres não numéricos
}

const toggleMenu = () => (mobileMenu.value = !mobileMenu.value);

const toggleUserMenu = () => {
  showUserMenu.value = !showUserMenu.value;
};

async function searchAds() {
  try {
    loading.value = true;
    const response = await api.get("/advertisements", {
      params: {
        search: filters.value.keyword || undefined,
        category_id: filters.value.category_id || undefined,
        state: filters.value.state || undefined,
      },
    });

    const data = response.data.data || [];
    const processed = processAds(data);

    // Divide os anúncios em premium e normais
    const premium = processed.filter(ad => ad.is_featured);
    const regular = processed.filter(ad => !ad.is_featured);
    const employability = processed.filter(ad => !ad.category.is_employability === 1);

    // Atualiza as duas seções
    premiumAds.value = premium;
    latestAds.value = regular;

    employabilityAds.value = employability

    // Atualiza flags de paginação (caso estejam sendo usadas)
    premiumHasMore.value = false;
    latestHasMore.value = false;
    employabilityHasMore.value = false;
  } catch (error) {
    console.error("Erro ao buscar anúncios:", error);
    Swal.fire({
      icon: "error",
      title: "Erro ao buscar anúncios",
      text: "Ocorreu um erro ao tentar carregar os anúncios.",
    });
  } finally {
    loading.value = false;
  }
}

async function goToAd(advertisement) {
  api.post(`/advertisement/view/${advertisement.id}`);
  router.push(`/anuncio/${advertisement.slug}`);
}

function logout() {
  localStorage.removeItem("userData");
  userName.value = '';
  isLoggedIn.value = false;

  Swal.fire({
    icon: "success",
    title: "Logout realizado",
    text: "Você saiu da sua conta com sucesso.",
    timer: 2000,
    showConfirmButton: false,
  });

  router.push("/");
}

function goToLogin() {
  router.push("/login");
}

const premiumPage = ref(1);
const latestPage = ref(1);
const employabilityPage = ref(1)
const perPage = 10;

const premiumHasMore = ref(false);
const latestHasMore = ref(false);
const employabilityHasMore = ref(false);

async function getPremiumAdvertisements(loadMore = false) {
  try {
    loading.value = true;
    const page = loadMore ? premiumPage.value + 1 : 1;

    const response = await api.get('/advertisements', {
      params: { page, per_page: perPage, is_featured: 1, employability: 0 },
    });

    const data = response.data.data || [];
    const processed = processAds(data);

    premiumAds.value = loadMore ? [...premiumAds.value, ...processed] : processed;
    premiumHasMore.value = data.length === perPage;

    if (premiumHasMore.value) premiumPage.value = page;
  } catch (error) {
    console.error("Erro ao carregar anúncios premium:", error);
    Swal.fire({ icon: "error", title: "Erro ao carregar destaques" });
  } finally {
    loading.value = false;
  }
}

async function getLatestAdvertisements(loadMore = false) {
  try {
    loading.value = true;
    const page = loadMore ? latestPage.value + 1 : 1;

    const response = await api.get('/advertisements', {
      params: { page, per_page: perPage, is_featured: 0, employability: 0 },
    });

    const data = response.data.data || [];
    const processed = processAds(data);

    latestAds.value = loadMore ? [...latestAds.value, ...processed] : processed;
    latestHasMore.value = data.length === perPage;

    if (latestHasMore.value) latestPage.value = page;
  } catch (error) {
    console.error("Erro ao carregar anúncios recentes:", error);
    Swal.fire({ icon: "error", title: "Erro ao carregar anúncios" });
  } finally {
    loading.value = false;
  }
}

async function getEmployabilityAdvertisements(loadMore = false) {
  try {
    loading.value = true;
    const page = loadMore ? employabilityPage.value + 1 : 1;

    const response = await api.get('/advertisements', {
      params: { page, per_page: perPage, is_featured: 0, employability: 1 },
    });

    const data = response.data.data || [];
    const processed = processAds(data);

    employabilityAds.value = loadMore ? [...employabilityAds.value, ...processed] : processed;
    employabilityHasMore.value = data.length === perPage;

    if (employabilityHasMore.value) employabilityPage.value = page;
  } catch (error) {
    console.error("Erro ao carregar anúncios empregos:", error);
    Swal.fire({ icon: "error", title: "Erro ao carregar empregos" });
  } finally {
    loading.value = false;
  }
}

function processAds(ads) {
  return ads.map((ad) => {
    let imgs = [];

    try {
      const parsed = JSON.parse(ad.images || "[]");
      imgs = parsed.map((img) => `${app_url_api_storage}/images/${img}`);
    } catch {
      imgs = [];
    }

    return {
      id: ad.id,
      title: ad.title,
      city: ad.city,
      state: ad.state,
      slug: ad.slug,
      category_name: ad.category?.description || "",
      client_phone: ad.client?.phone || "",
      images: imgs.length > 0 ? imgs : ["/placeholder.jpg"],
      is_featured: ad.is_featured,
      category: ad.category,
      client: ad.client,
      coverage: ad.coverage || 'local',
    };
  });
}

async function getCategories() {
  try {
    const response = await api.get('/categories', {
      params: { is_active: 1 }
    });

    categories.value = response.data.data || [];
  } catch (error) {
    console.error('Erro ao carregar corretores:', error);
    Swal.fire({
      icon: "error",
      title: "Erro ao carregar categorias",
      text: "Não foi possível carregar as categorias.",
    });
  }
}

async function getEnterpriseData() {
  try {
    const response = await api.get('/enterprise/home');
    enterpriseData.value = response.data.data[0] || {};
  } catch (error) {
    console.error('Erro ao carregar empresa:', error);
    Swal.fire({
      icon: "error",
      title: "Erro ao carregar dados da empresa",
      text: "Verifique sua conexão e tente novamente.",
    });
  }
}

function handleCreateAd() {
  const storedUser = localStorage.getItem("userData");
  if (!storedUser) {
    Swal.fire({
      icon: "info",
      title: "Acesso restrito",
      text: "Você precisa estar logado para criar um anúncio.",
      confirmButtonText: "Fazer login",
    }).then(() => {
      router.push({ path: "/login", query: { redirect: "/cadastre-seu-anuncio" } });
    });
    return;
  }
  router.push("/cadastre-seu-anuncio");
}

function handleUserAction(action) {
  showUserMenu.value = false;
  switch (action) {
    case "dashboard":
      router.push("/app/dashboard");
      break;
    case "meuAnuncio":
      router.push("/cadastre-seu-anuncio");
      break;
    case "changePassword":
      showPasswordDialog.value = true;
      break;
    case "logout":
      logout();
      break;
  }
}

async function changePassword() {
  try {
    if (!passwordData.value.newPassword || passwordData.value.newPassword !== passwordData.value.confirmPassword) {
      Swal.fire({
        icon: "warning",
        title: "Senhas não coincidem",
        text: "Verifique e tente novamente.",
      });
      return;
    }

    await api.put(`/users/${userID.value}/password`, {
      old_password: passwordData.value.oldPassword,
      password: passwordData.value.newPassword,
    });

    Swal.fire({
      icon: "success",
      title: "Senha alterada",
      text: "Sua senha foi atualizada com sucesso!",
      timer: 2500,
      showConfirmButton: false,
    });
    showPasswordDialog.value = false;
    passwordData.value = { oldPassword: "", newPassword: "", confirmPassword: "" };
  } catch (error) {
    console.error("Erro ao alterar senha:", error);
    Swal.fire({
      icon: "error",
      title: "Erro ao alterar senha",
      text: "Verifique os dados e tente novamente.",
    });
  }
}

onMounted(async () => {
  await Promise.all([
    getPremiumAdvertisements(),
    getLatestAdvertisements(),
    getEmployabilityAdvertisements(),
    getCategories(),
    getEnterpriseData(),
  ]);

  const storedUser = localStorage.getItem("userData");
  if (storedUser) {
    const user = JSON.parse(storedUser);
    userName.value = user?.user?.name || "Usuário";
    userID.value = user?.user?.id || null;
    isLoggedIn.value = true;
    isAdmin.value = user?.user?.role === 'admin' || user?.user?.role === 'administrative';
  }

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".relative")) showUserMenu.value = false;
  });
});

</script>

<style scoped>
/* ============================================== */
/* IDENTIDADE VISUAL SÊNIOR SHOPPING             */
/* ============================================== */

/* Cor Dourada - Accent (#CBA34B) */
.text-accent {
  color: #CBA34B !important;
}

.bg-accent {
  background-color: #CBA34B !important;
}

/* Cor Primária - Azul Institucional (#163C53) */
.text-primary {
  color: #163C53 !important;
}

.bg-primary {
  background-color: #163C53 !important;
}

/* Cor Secundária - Verde Saúde (#82A097) */
.hover\:bg-secondary:hover {
  background-color: #82A097 !important;
}

/* Cor de Fundo - Bege (#F1E9D4) */
.bg-neutrals_background {
  background-color: #F1E9D4 !important;
}

/* Restante do CSS mantido */
.text-neutrals_text {
  color: #1f2937;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

/* Transições de Opacidade (para o User Menu e Dialog) */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>